import * as React from "react";
const NoEvent = (props) => (
    <svg
        width={178}
        height={179}
        viewBox="0 0 178 179"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M109.433 137.938H46.706c-4.415 0-8.03-3.625-8.03-8.055V40.432c0-4.43 3.615-8.053 8.03-8.053h62.727c4.417 0 8.031 3.623 8.031 8.053v89.451c0 4.43-3.614 8.055-8.031 8.055"
            fill="#E0E2EE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M104.078 141.763H41.351c-4.415 0-8.029-3.625-8.029-8.055V44.256c0-4.43 3.614-8.052 8.03-8.052h62.726c4.417 0 8.031 3.622 8.031 8.052v89.452c0 4.43-3.614 8.055-8.031 8.055"
            fill="#E8EBF2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M98.87 144.782H36.013c-4.424 0-8.045-3.61-8.045-8.022V47.679c0-4.412 3.621-8.02 8.045-8.02H98.87c4.426 0 8.047 3.608 8.047 8.02v89.081c0 4.412-3.621 8.022-8.047 8.022"
            fill="#D8DBEA"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M98.87 144.782H36.013c-4.424 0-8.045-3.61-8.045-8.022V47.679c0-4.412 3.621-8.02 8.045-8.02H98.87c4.426 0 8.047 3.608 8.047 8.02v89.081c0 4.412-3.621 8.022-8.047 8.022"
            fill="#F1F2F7"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.811 66.8H43.384c-1.326 0-2.411-1.032-2.411-2.293 0-1.263 1.085-2.296 2.41-2.296h46.428c1.326 0 2.411 1.033 2.411 2.296 0 1.261-1.085 2.294-2.41 2.294m-.001 13.768H43.384c-1.326 0-2.411-1.032-2.411-2.294s1.085-2.296 2.41-2.296h46.428c1.326 0 2.411 1.033 2.411 2.296 0 1.261-1.085 2.294-2.41 2.294m-.002 13.769H43.383c-1.326 0-2.411-1.033-2.411-2.294s1.085-2.296 2.41-2.296H89.81c1.326 0 2.411 1.034 2.411 2.296s-1.085 2.294-2.41 2.294m0 13.769H43.384c-1.326 0-2.411-1.033-2.411-2.294 0-1.263 1.085-2.296 2.41-2.296h46.428c1.326 0 2.411 1.033 2.411 2.296 0 1.261-1.085 2.294-2.41 2.294m-22.194 13.768H43.394c-1.331 0-2.421-1.033-2.421-2.294 0-1.263 1.09-2.296 2.421-2.296h24.224c1.332 0 2.422 1.033 2.422 2.296 0 1.261-1.09 2.294-2.422 2.294"
            fill="#E0E2EE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M108.519 104.08c-9.283 9.282-23.656 10.329-34.09 3.162a28 28 0 0 1-3.786-3.162 25.8 25.8 0 0 1-4.532-6.069 25.6 25.6 0 0 1-2.807-7.745c-1.639-8.435.812-17.514 7.34-24.038 6.542-6.544 15.623-8.979 24.06-7.356a26.5 26.5 0 0 1 7.746 2.807 27 27 0 0 1 4.16 2.824 26 26 0 0 1 1.892 1.725 26.7 26.7 0 0 1 3.163 3.785c7.17 10.43 6.12 24.802-3.146 34.067"
            fill="#fff"
            fillOpacity={0.1}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M105.923 102.252c-9.658 9.66-25.31 9.658-34.97 0-9.648-9.648-9.648-25.302.012-34.96 9.648-9.648 25.3-9.648 34.947 0 9.659 9.658 9.659 25.312.011 34.96m4.956-39.923c-12.398-12.397-32.487-12.397-44.885 0-12.395 12.396-12.406 32.498-.01 44.895 11.283 11.28 28.968 12.297 41.406 3.036a32 32 0 0 0 3.501-3.036 32 32 0 0 0 3.034-3.501c9.261-12.44 8.235-30.112-3.046-41.394"
            fill="#E0E2EE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m159.667 153.956-.52.52c-3.443 3.446-9.082 3.446-12.527 0l-31.794-31.793 13.048-13.048 31.793 31.794c3.446 3.445 3.446 9.082 0 12.527"
            fill="#66C4CA"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m114.61 102.751 9.395 9.395-6.67 6.668-9.394-9.395a33 33 0 0 0 3.573-3.097 32.5 32.5 0 0 0 3.096-3.571"
            fill="#E0E2EE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m159.192 141.038-12.964 12.963-2.334-2.336 12.962-12.962zm-30.598-30.954-13.319 13.32-1.979-1.979 13.319-13.32z"
            fill="#009CA6"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M99.528 63.969 66.863 96.631a23 23 0 0 1-2.521-6.963l28.223-28.224a23.9 23.9 0 0 1 6.963 2.523m10.709 7.766-35.314 33.313a26 26 0 0 1-3.591-2.828 23 23 0 0 1-1.636-1.695L105.441 66.8c.625.484 1.22 1 1.796 1.545a24.4 24.4 0 0 1 3 3.388"
            fill="#fff"
            fillOpacity={0.5}
        />
        <path
            d="M9.326 47.846v2.442M2 55.17h2.442m4.882 6.512V59.24m6.514-4.07h-2.441"
            stroke="#D2D8DF"
            strokeWidth={2.921}
            strokeLinecap="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.624 159.218c2.092-.652 5.298-3.21 6.04-5.963.673 2.433 3.494 5.311 6.04 5.528-2.866 1.015-5.605 4.029-6.04 6.397-.296-2.413-4.085-5.61-6.04-5.962"
            fill="#EBECEE"
        />
        <path
            clipRule="evenodd"
            d="M126.956 4.732a2.731 2.731 0 1 1-5.463.002 2.731 2.731 0 0 1 5.463-.002ZM60.349 176.778a3.382 3.382 0 1 1-2.405-6.322 3.382 3.382 0 0 1 2.405 6.322Z"
            stroke="#D2D8DF"
            strokeWidth={2.921}
            strokeLinecap="round"
        />
    </svg>
);
export default NoEvent;
